export const hospitalDenialsColumns = [
  'id',
  '_cdc_hash',
  '_cdc_seq',
  'r1_id',
  'revint_id',
  'account_number',
  'amount',
  'claim_number',
  'cpt',
  'date',
  'denial_id',
  'facility_id',
  'fk_hospital__data_doc_new_id',
  'hcpcs',
  'line_item_modifier_codes',
  'line_item_procedure_codes',
  'metadata__correlation_derived_date',
  'metadata__correlation_id',
  'metadata__engagement_id',
  'metadata__engagement_name',
  'metadata__modified_by',
  'metadata__modified_date',
  'metadata__pipeline_id',
  'metadata__pipeline_name',
  'modifier1',
  'modifier2',
  'modifier3',
  'modifier4',
  'payer__payer_name',
  'payer__payer_position',
  'payer__plan_code',
  'payer__plan_name',
  'reason_code',
  'reason_group',
  'revenue_code',
  'snapshot_id',
];
